// https://web.dev/optimize-long-tasks
// yield to the main thread by briefly interrupting the task queue
// to give the browser opportunities to run more important tasks
function yieldToMain() {
  return new Promise((resolve) => {
    setTimeout(resolve, 0);
  });
}

export default yieldToMain;
